const SHOWCASE_KEY = 'prufa-showcase'

const now = () => Date.now()
const hoursAgo = (hours) => new Date(now() - hours * 60 * 60 * 1000).toISOString()
const hoursFromNow = (hours) => new Date(now() + hours * 60 * 60 * 1000).toISOString()
const daysFromNow = (days) => new Date(now() + days * 24 * 60 * 60 * 1000).toISOString()

const workspaceId = 'ws_showcase'
const tierLimits = { free: 5, agent_temp: 100, starter: 500, pro: 5000, team: 50000 }
const paidTiers = ['starter', 'pro', 'team']

function showcaseTier() {
  const tier = new URLSearchParams(window.location.search).get('tier')
  return tier && tier in tierLimits ? tier : 'starter'
}

const currentTier = showcaseTier()
const currentCallsUsed = {
  free: 2,
  agent_temp: 34,
  starter: 342,
  pro: 1842,
  team: 7200,
}[currentTier]

const user = {
  workspace_id: workspaceId,
  email: 'gregory@example.com',
  display_name: 'Gregory',
  avatar_url: '',
  tier: currentTier,
  is_paid: paidTiers.includes(currentTier),
  has_google: true,
  has_password: true,
  email_verified: true,
  cookie_consent_analytics: false,
}

const usage = {
  workspace_id: workspaceId,
  tier: currentTier,
  calls_used: currentCallsUsed,
  calls_included: tierLimits[currentTier],
  calls_remaining: Math.max(0, tierLimits[currentTier] - currentCallsUsed),
  opt_in_to_overage: false,
  period_end: daysFromNow(9),
  monitor_paused_at: null,
}

const flowSpecs = {
  'flow-login': {
    flow_id: 'flow-login',
    workspace_id: workspaceId,
    name: 'login-happy-path',
    url: 'https://app.acme.test/login',
    status: 'confirmed',
    created_at: hoursAgo(30),
    confirmed_at: hoursAgo(28),
    variables: ['TEST_EMAIL', 'TEST_PASSWORD'],
    credentials: ['TEST_EMAIL', 'TEST_PASSWORD'],
    spec: {
      version: 1,
      steps: [
        { type: 'goto', url: 'https://app.acme.test/login' },
        { type: 'act', action: 'fill', target: 'email field', selector: 'input[name="email"]', value: '{{TEST_EMAIL}}' },
        { type: 'act', action: 'fill', target: 'password field', selector: 'input[name="password"]', value: '{{TEST_PASSWORD}}' },
        { type: 'act', action: 'click', target: 'Sign in button', selector: 'button[type="submit"]' },
        { type: 'expect', kind: 'url_contains', value: '/dashboard' },
        { type: 'expect', kind: 'text_contains', selector: 'main', value: 'Revenue overview' },
      ],
      assertions: [
        { kind: 'console_errors', severity: 'critical' },
        { kind: 'beacon', vendor: 'posthog', event: 'dashboard_loaded', severity: 'warning' },
      ],
    },
  },
  'flow-checkout': {
    flow_id: 'flow-checkout',
    workspace_id: workspaceId,
    name: 'checkout-upgrade',
    url: 'https://app.acme.test/pricing',
    status: 'draft',
    created_at: hoursAgo(5),
    confirmed_at: null,
    variables: ['TEST_EMAIL'],
    credentials: ['TEST_EMAIL'],
    spec: {
      version: 1,
      steps: [
        { type: 'goto', url: 'https://app.acme.test/pricing' },
        { type: 'act', action: 'click', target: 'Pro plan button', selector: '[data-plan="pro"]' },
        { type: 'expect', kind: 'url_contains', value: 'checkout.stripe.com' },
        { type: 'expect', kind: 'text_contains', selector: 'body', value: 'Acme Pro' },
      ],
      assertions: [
        { kind: 'beacon', vendor: 'stripe', event: 'checkout_started', severity: 'warning' },
      ],
    },
  },
  'flow-signup': {
    flow_id: 'flow-signup',
    workspace_id: workspaceId,
    name: 'signup-happy-path',
    url: 'https://app.acme.test/signup',
    status: 'confirmed',
    created_at: hoursAgo(54),
    confirmed_at: hoursAgo(53),
    variables: [],
    credentials: [],
    spec: {
      version: 1,
      steps: [
        { type: 'goto', url: 'https://app.acme.test/signup' },
        { type: 'act', action: 'fill', target: 'email field', selector: 'input[name="email"]', value: 'qa+prufa@acme.test' },
        { type: 'act', action: 'click', target: 'Create account button', selector: 'button[type="submit"]' },
        { type: 'expect', kind: 'url_contains', value: '/welcome' },
        { type: 'expect', kind: 'text_contains', selector: 'main', value: 'Confirm your email' },
      ],
      assertions: [
        { kind: 'console_errors', severity: 'critical' },
      ],
    },
  },
}

const flows = Object.values(flowSpecs).map((flow) => ({
  flow_id: flow.flow_id,
  name: flow.name,
  url: flow.url,
  status: flow.status,
  created_at: flow.created_at,
  confirmed_at: flow.confirmed_at,
}))

const monitors = [
  {
    id: 'mon-checkout',
    workspace_id: workspaceId,
    url: 'https://app.acme.test/pricing',
    cadence: 'hourly',
    flow_id: 'flow-checkout',
    status: 'failing',
    last_run_status: 'failed',
    last_run_at: hoursAgo(2.3),
    next_run_at: hoursFromNow(0.7),
    consecutive_failures: 3,
    report_url: '/r/showcase-checkout',
  },
  {
    id: 'mon-login',
    workspace_id: workspaceId,
    url: 'https://app.acme.test/login',
    cadence: 'hourly',
    flow_id: 'flow-login',
    status: 'active',
    last_run_status: 'succeeded',
    last_run_at: hoursAgo(0.6),
    next_run_at: hoursFromNow(0.4),
    consecutive_failures: 0,
    report_url: '/r/showcase-login',
  },
  {
    id: 'mon-signup',
    workspace_id: workspaceId,
    url: 'https://app.acme.test/signup',
    cadence: 'hourly',
    flow_id: 'flow-signup',
    status: 'active',
    last_run_status: 'succeeded',
    last_run_at: hoursAgo(0.4),
    next_run_at: hoursFromNow(0.6),
    consecutive_failures: 0,
    report_url: '/r/showcase-signup',
  },
  {
    id: 'mon-marketing',
    workspace_id: workspaceId,
    url: 'https://acme.test',
    cadence: 'daily',
    flow_id: '',
    status: 'active',
    last_run_status: 'succeeded',
    last_run_at: hoursAgo(11),
    next_run_at: hoursFromNow(13),
    consecutive_failures: 0,
    report_url: '/r/showcase-marketing',
  },
]

const monitorDetails = {
  'mon-checkout': {
    ...monitors[0],
    deploy_hook: {
      url: 'https://prufa.dev/api/v1/monitors/mon-checkout/webhook',
      header: 'X-Prufa-Deploy-Hook',
      never_fired: false,
    },
    recent_runs: [
      {
        run_id: 'run_checkout_003',
        status: 'failed',
        created_at: hoursAgo(2.3),
        failure_reason: 'Stripe checkout opened, but plan copy changed from "Acme Pro" to "Growth".',
        report_url: '/r/showcase-checkout-003',
      },
      {
        run_id: 'run_checkout_002',
        status: 'failed',
        created_at: hoursAgo(3.2),
        failure_reason: 'Expected checkout.stripe.com after clicking the Pro plan button.',
        report_url: '/r/showcase-checkout-002',
      },
      {
        run_id: 'run_checkout_001',
        status: 'succeeded',
        created_at: hoursAgo(5.5),
        failure_reason: '',
        report_url: '/r/showcase-checkout-001',
      },
    ],
  },
  'mon-login': {
    ...monitors[1],
    deploy_hook: {
      url: 'https://prufa.dev/api/v1/monitors/mon-login/webhook',
      header: 'X-Prufa-Deploy-Hook',
      never_fired: false,
    },
    recent_runs: [
      {
        run_id: 'run_login_044',
        status: 'succeeded',
        created_at: hoursAgo(0.6),
        failure_reason: '',
        report_url: '/r/showcase-login-044',
      },
      {
        run_id: 'run_login_043',
        status: 'succeeded',
        created_at: hoursAgo(1.6),
        failure_reason: '',
        report_url: '/r/showcase-login-043',
      },
    ],
  },
}

const deliveries = {
  deliveries: [
    { status: 'accepted', reason: 'deploy: production-2026-06-12.4', created_at: hoursAgo(2.4), run_id: 'run_checkout_003' },
    { status: 'accepted', reason: 'deploy: production-2026-06-12.3', created_at: hoursAgo(5.6), run_id: 'run_checkout_001' },
    { status: 'rejected', reason: 'bad signature from staging job', created_at: hoursAgo(22), run_id: null },
  ],
  never_fired: false,
  snippets: {
    curl: 'curl -X POST "$PRUFA_DEPLOY_HOOK_URL" \\\n  -H "X-Prufa-Deploy-Hook: $PRUFA_DEPLOY_HOOK_SECRET"',
    github_actions: 'name: Prufa deploy check\non: [deployment_status]\njobs:\n  verify:\n    runs-on: ubuntu-latest\n    steps:\n      - run: curl -X POST "$PRUFA_DEPLOY_HOOK_URL" -H "X-Prufa-Deploy-Hook: $PRUFA_DEPLOY_HOOK_SECRET"',
    gitlab_ci: 'prufa_deploy_check:\n  stage: deploy\n  script:\n    - curl -X POST "$PRUFA_DEPLOY_HOOK_URL" -H "X-Prufa-Deploy-Hook: $PRUFA_DEPLOY_HOOK_SECRET"',
  },
}

const apiKeys = [
  {
    id: 'key_cli',
    label: 'Claude Code on laptop',
    key_hash_prefix: 'prf_live_8d91',
    created_at: hoursAgo(72),
    last_used_at: hoursAgo(0.2),
    revoked_at: null,
  },
  {
    id: 'key_ci',
    label: 'GitLab production deploy hook',
    key_hash_prefix: 'prf_live_6ac4',
    created_at: hoursAgo(120),
    last_used_at: hoursAgo(2.4),
    revoked_at: null,
  },
]

const runs = [
  { id: 'run_login_044', status: 'succeeded', url: 'https://app.acme.test/login', created_at: hoursAgo(0.6), report_url: '/r/showcase-login-044' },
  { id: 'run_checkout_003', status: 'failed', url: 'https://app.acme.test/pricing', created_at: hoursAgo(2.3), report_url: '/r/showcase-checkout-003' },
  { id: 'run_marketing_091', status: 'succeeded', url: 'https://acme.test', created_at: hoursAgo(11), report_url: '/r/showcase-marketing-091' },
  { id: 'run_signup_017', status: 'blocked', url: 'https://app.acme.test/signup', created_at: hoursAgo(18), report_url: '/r/showcase-signup-017' },
]

const manualAuditRun = {
  id: 'run_manual_001',
  status: 'succeeded',
  url: 'https://lobsterland.ing',
  created_at: new Date().toISOString(),
  report_url: '/r/showcase-manual-001',
}

const manualAuditEvents = [
  ['queued', { url: manualAuditRun.url }],
  ['page_loaded', { url: manualAuditRun.url, status: 200 }],
  ['pixels_detected', { count: 3 }],
  ['consent_checking', {}],
  ['links_checked', { checked: 14 }],
  ['advisory_checking', {}],
  ['seo_checked', { findings: 2 }],
  ['ux_checked', { findings: 1 }],
  ['compiling_report', {}],
  ['report_ready', { run_id: manualAuditRun.id }],
]

function json(body, init = {}) {
  return new Response(JSON.stringify(body), {
    status: init.status || 200,
    headers: { 'Content-Type': 'application/json', ...(init.headers || {}) },
  })
}

function noContent() {
  return new Response(null, { status: 204 })
}

function requestPath(input) {
  const raw = typeof input === 'string' ? input : input?.url
  return new URL(raw, window.location.origin).pathname
}

function requestMethod(input, init) {
  return (init?.method || (typeof input !== 'string' && input?.method) || 'GET').toUpperCase()
}

function readBody(init) {
  if (!init?.body || typeof init.body !== 'string') return {}
  try {
    return JSON.parse(init.body)
  } catch {
    return {}
  }
}

function handleMockRequest(input, init) {
  const path = requestPath(input)
  const method = requestMethod(input, init)

  if (path === '/api/auth/me' && method === 'GET') return json(user)
  if (path === '/api/auth/account/analytics-consent' && method === 'PATCH') {
    return json({ ...user, cookie_consent_analytics: Boolean(readBody(init).cookie_consent_analytics) })
  }
  if (path === '/api/auth/logout' && method === 'POST') return noContent()

  if (path === '/api/v1/workspaces/current' && (method === 'PATCH' || method === 'GET')) {
    return json({
      workspace_id: workspaceId,
      tier: currentTier,
      is_paid: paidTiers.includes(currentTier),
      is_in_trial: currentTier === 'agent_temp',
      trial_expires_at: currentTier === 'agent_temp' ? daysFromNow(5) : null,
      slack_channel: '#deploy-watch',
      usage_webhook_url: 'https://api.acme.test/hooks/prufa-usage',
      usage_webhook_secret_set: true,
      usage,
    })
  }
  if (path === '/api/v1/workspaces/current/usage') return json(usage)
  if (path === '/api/v1/workspaces/current/usage-webhook/test' && method === 'POST') {
    return json({ ok: true })
  }
  if (path === '/api/v1/billing/portal' && method === 'POST') {
    return json({ portal_url: 'https://billing.stripe.com/showcase/prufa' })
  }

  if (path === '/api/v1/audits' && method === 'GET') return json({ runs })
  if (path === '/api/v1/audits' && method === 'POST') {
    return json({
      run_id: manualAuditRun.id,
      status: 'queued',
      report_url: manualAuditRun.report_url,
      events_url: `/api/v1/audits/${manualAuditRun.id}/events`,
    }, { status: 201 })
  }
  if (path === `/api/v1/audits/${manualAuditRun.id}` && method === 'GET') return json(manualAuditRun)

  if (path === '/api/v1/monitors' && method === 'GET') return json({ monitors, usage })
  if (path === '/api/v1/monitors' && method === 'POST') {
    const body = readBody(init)
    return json({
      id: 'mon-new-showcase',
      workspace_id: workspaceId,
      url: body.url || 'https://new.example.test',
      cadence: body.cadence || 'daily',
      flow_id: body.flow_id || '',
      status: 'active',
      last_run_status: 'queued',
      last_run_at: null,
      next_run_at: hoursFromNow(24),
      consecutive_failures: 0,
      deploy_hook: {
        url: '/api/v1/monitors/mon-new-showcase/webhook',
        header: 'X-Prufa-Deploy-Hook',
        secret: 'prufa_dh_showcase_store_once',
      },
      usage,
    }, { status: 201 })
  }

  const monitorRunMatch = path.match(/^\/api\/v1\/monitors\/([^/]+)\/run$/)
  if (monitorRunMatch && method === 'POST') {
    return json({ run_id: 'run_queued_showcase', report_url: '/r/showcase-queued', deduped: false, usage })
  }
  const monitorDeliveriesMatch = path.match(/^\/api\/v1\/monitors\/([^/]+)\/deliveries$/)
  if (monitorDeliveriesMatch && method === 'GET') return json(deliveries)
  const monitorRotateMatch = path.match(/^\/api\/v1\/monitors\/([^/]+)\/webhook\/rotate$/)
  if (monitorRotateMatch && method === 'POST') return json({ secret: 'prufa_dh_rotated_showcase_store_once' })
  const monitorMatch = path.match(/^\/api\/v1\/monitors\/([^/]+)$/)
  if (monitorMatch) {
    const id = monitorMatch[1]
    if (method === 'GET') return json(monitorDetails[id] || monitorDetails['mon-checkout'])
    if (method === 'PATCH') {
      const current = monitorDetails[id] || monitorDetails['mon-checkout']
      return json({ ...current, ...readBody(init) })
    }
    if (method === 'DELETE') return noContent()
  }

  if (path === '/api/v1/flows' && method === 'GET') return json({ flows })
  if (path === '/api/v1/flows' && method === 'POST') {
    return json({ ...flowSpecs['flow-checkout'], flow_id: 'flow-new-showcase', name: readBody(init).name || 'new-showcase-flow' }, { status: 201 })
  }
  const flowConfirmMatch = path.match(/^\/api\/v1\/flows\/([^/]+)\/confirm$/)
  if (flowConfirmMatch && method === 'POST') {
    const flow = flowSpecs[flowConfirmMatch[1]] || flowSpecs['flow-checkout']
    return json({ ...flow, status: 'confirmed', confirmed_at: new Date().toISOString() })
  }
  const flowCredentialsMatch = path.match(/^\/api\/v1\/flows\/([^/]+)\/credentials$/)
  if (flowCredentialsMatch && method === 'PUT') {
    return json({ stored: Object.keys(readBody(init).credentials || {}) })
  }
  const flowRunMatch = path.match(/^\/api\/v1\/flows\/([^/]+)\/run$/)
  if (flowRunMatch && method === 'POST') {
    return json({ run_id: 'run_flow_showcase', report_url: '/r/showcase-flow-run' })
  }
  const flowMatch = path.match(/^\/api\/v1\/flows\/([^/]+)$/)
  if (flowMatch) {
    const flow = flowSpecs[flowMatch[1]] || flowSpecs['flow-login']
    if (method === 'GET') return json(flow)
    if (method === 'PUT') return json({ ...flow, spec: readBody(init).spec, status: 'draft', confirmed_at: null })
  }

  if (path === '/api/v1/auth/api-keys' && method === 'GET') return json(apiKeys)
  if (path === '/api/v1/auth/api-keys' && method === 'POST') {
    return json({
      id: 'key_new',
      label: readBody(init).label || 'Showcase key',
      plaintext: 'prf_showcase_key_not_a_secret_123456',
    }, { status: 201 })
  }
  if (path.match(/^\/api\/v1\/auth\/api-keys\/[^/]+$/) && method === 'DELETE') return noContent()

  return null
}

function installShowcaseEventSource() {
  const RealEventSource = window.EventSource

  class MockAuditEventSource extends EventTarget {
    constructor(url) {
      super()
      this.url = url
      this.readyState = 0
      this.timers = []
      this.onopen = null
      this.onerror = null

      this.timers.push(window.setTimeout(() => {
        if (this.readyState === 2) return
        this.readyState = 1
        this.onopen?.(new Event('open'))
        this.dispatchEvent(new Event('open'))
      }, 80))

      manualAuditEvents.forEach(([event, data], index) => {
        this.timers.push(window.setTimeout(() => {
          if (this.readyState === 2) return
          this.dispatchEvent(new MessageEvent(event, { data: JSON.stringify(data) }))
        }, 250 + index * 300))
      })
    }

    close() {
      this.readyState = 2
      for (const timer of this.timers) window.clearTimeout(timer)
      this.timers = []
    }
  }

  window.EventSource = function ShowcaseEventSource(url, options) {
    const path = new URL(url, window.location.origin).pathname
    if (path === `/api/v1/audits/${manualAuditRun.id}/events`) {
      return new MockAuditEventSource(url)
    }
    return new RealEventSource(url, options)
  }
}

function shouldEnableShowcase() {
  const params = new URLSearchParams(window.location.search)
  if (params.get('showcase') === '0') {
    localStorage.removeItem(SHOWCASE_KEY)
    return false
  }
  if (params.get('showcase') === '1') {
    localStorage.setItem(SHOWCASE_KEY, '1')
    return true
  }
  return localStorage.getItem(SHOWCASE_KEY) === '1'
}

export function installShowcaseMocks() {
  if (!import.meta.env.DEV || !shouldEnableShowcase() || window.__prufaShowcaseMocks) return
  window.__prufaShowcaseMocks = true
  localStorage.setItem(`prufa.onboarding-tour.completed.${workspaceId}`, '1')
  localStorage.removeItem(`prufa.onboarding-tour.pending.${workspaceId}`)
  localStorage.removeItem(`prufa.onboarding-tour.active.${workspaceId}`)
  const realFetch = window.fetch.bind(window)
  window.fetch = async (input, init) => {
    const mocked = handleMockRequest(input, init)
    if (mocked) return mocked
    return realFetch(input, init)
  }
  if (window.EventSource) installShowcaseEventSource()
  console.info('[prufa] showcase mocks enabled')
}
